// Card variants for catalog product cards, driving how a card's primary
// action behaves when a user interacts with it.
export const CARD_VARIANTS = {
  // Single click adds the product straight to the order.
  DIRECT_ADD_TO_ORDER: 'directAddToOrder',
  // Opens the plan selector to render the plan's fields, validates them
  // (including any field-level API validation), then adds to the order.
  VIEW_CONFIGURATION: 'viewConfiguration',
  // Increment/decrement controls add or update the product's quantity directly.
  DIRECT_STEPPER: 'directStepper',
  // A dropdown lets the user pick a tier/option; selecting one adds or
  // updates the product directly without opening the plan selector.
  DIRECT_OPTIONS_SELECTOR: 'directOptionsSelector',
}
